import Event from "../../../../src/events/2021/12/event-pro/event";
import * as React from 'react';
export default {
  Event,
  React
};